import Modal from "global/component/Genericos/Modal/Modal";
import { GlobalContext } from "global/context/Provider";
import { useContext } from "react";
import { PortalContext } from "_+_Portal/context/Provider";
import BtnLink from "_+_Portal/_-_Autocheckin/components/genericos/BtnLink/BtnLink";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BtnContainer,
  ContainerNecesitoTurno,
  TextNecesitoTurno,
} from "./localStyle";
import camelize from "global/utils/camelize";
import { useHistory } from "react-router";
import TildeOk from "_+_Portal/assets/images/generico/TildeOk";
import MiTurnoIcon from "_+_Portal/assets/images/generico/MiTurnoIcon";
import { containerVariants, itemVariants } from "global/utils/btnTransition";
import { motion } from "framer-motion";
import { getLocalStorage } from "global/utils/safeJsonParse";

const TipoTurnoConsulta = ({ setLoading }) => {
  // -------------------------  context ----------------------------
  const { pasoDispatch } = useContext(AutocheckContext);
  const { modalState, authState } = useContext(GlobalContext);
  const { selectDropDownState } = useContext(PortalContext);
  // -------------------------  context ----------------------------

  // -------------------------  constantes ----------------------------
  const pacienteNombre = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.nombre
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.nombre
    : authState?.auth?.data?.paciente?.nombre;
  let idTerminal = getLocalStorage("idTerminal");
  const history = useHistory();

  // -------------------------  constantes ----------------------------

  const handleOnclick = (path) => {
    if (path === "CONSULTA") {
      setPaso("MasSolicitadosConsultas")(pasoDispatch);
    } else if (path === "OTRAS") {
      if (idTerminal) {
        history.push("/buscadorCheckin");
      } else {
        history.push("/consultamedica");
      }
    }
  };

  return (
    <>
      {modalState.modal.show && <Modal />}
      <LayoutPasos
        title={"Necesito turno"}
        subtitle={camelize("Para: " + pacienteNombre)}
      >
        <ContainerNecesitoTurno
          initial="hidden"
          animate="show"
          variants={containerVariants}
        >
          <TextNecesitoTurno $isTerminal={idTerminal}>
            <span className="title-saludo">
              <span className="title-negrita">
                Puede buscar turnos para consultas en base a sus turnos
                frecuentes, turnos recomendados por su edad o acceder al
                buscador con todas las disponibles
              </span>
            </span>
          </TextNecesitoTurno>
          <BtnContainer>
            <motion.div variants={itemVariants}>
              <BtnLink
                Icon={<TildeOk color={"var(--color-primary)"} />}
                type={"NORMAL"}
                title={"Mis consultas más solicitadas"}
                onclick={() => handleOnclick("CONSULTA")}
              />
            </motion.div>
            <motion.div variants={itemVariants}>
              <BtnLink
                Icon={<MiTurnoIcon color={"var(--color-primary)"} />}
                type={"NORMAL"}
                title={"Otras consultas"}
                onclick={() => handleOnclick("OTRAS")}
              />
            </motion.div>
          </BtnContainer>
        </ContainerNecesitoTurno>
      </LayoutPasos>
    </>
  );
};

export default TipoTurnoConsulta;
